import React, { lazy } from 'react';

const TradeInComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-trade-in" */ '~/purchase-ui/src/components/app/steps/trade-in'
  )
);

export const TradeInRoute = () => {
  return <TradeInComponent />;
};
